import type { CardStatus } from "../chat/controller";

export function CardStatusLine({ status }: { status: CardStatus }) {
  if (status.state === "done") {
    return (
      <>
        <p className="xstatus xstatus--ok" role="status">
          <span aria-hidden="true">✓ </span>
          {status.text}
        </p>
        {status.warning ? <p className="xstatus xstatus--warn">{status.warning}</p> : null}
      </>
    );
  }
  if (status.state === "failed") {
    return (
      <p className={`xstatus ${status.reason === "changed" ? "xstatus--warn" : "xstatus--bad"}`} role="status">
        {status.text}
      </p>
    );
  }
  return null;
}

/** The server's advisory pending-change verdict; the pane's own check at apply time is authoritative. */
export function PendingWarning({ authors }: { authors: readonly string[] }) {
  const who = authors.length === 0 ? "a pending tracked change" : `a change by ${authors.slice(0, 2).join(" and ")}${authors.length > 2 ? " and others" : ""}`;
  return (
    <p className="warn">
      Touches {who}; Word will decide when you apply.
    </p>
  );
}
